import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import EntityStore from 'stores/EntityStore';
import Label from 'ui-library/bs/Label';

export function makeWelcomeText(): string {
  const currentUser = EntityStore.currentUser();
  const userName = currentUser?.name;
  const displayName = userName != null ? `, ${userName}` : '';
  return `Welcome to Benchling${displayName}!`;
}

export default function InfoSidePanel(props: {titleText: string; bodyText: string}): JSX.Element {
  return (
    <div className={css(styles.sidePanel)}>
      <Label>{makeWelcomeText()}</Label>
      <div className={css(styles.headerText)}>{props.titleText}</div>
      <div className={classNames(css(styles.bodyText), 'u-faded')}>{props.bodyText}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  sidePanel: {
    paddingTop: '83px',
  },
  headerText: {
    fontSize: '34px',
    lineHeight: '40px',
    marginTop: '15px',
  },
  bodyText: {
    fontSize: '18px',
    lineHeight: '24px',
    marginTop: '12px',
  },
});
